import { mcpTokenService } from "../services/mcpToken.service";
import { mcpTokenConstants } from "../constants/mcpToken.constants";

export const mcpTokenActions = {
  get,
  getById,
  getByClientId,
  create,
  update,
  clearSuccess,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    mcpTokenService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestParameters) {
    return { type: mcpTokenConstants.GET_REQUEST, payload: requestParameters };
  }
  function success(data) {
    return { type: mcpTokenConstants.GET_SUCCESS, payload: data };
  }
  function failure(error) {
    return { type: mcpTokenConstants.GET_FAILURE, payload: error };
  }
}

function getById(mcpTokenId) {
  return (dispatch) => {
    dispatch(request(mcpTokenId));

    mcpTokenService.getById(mcpTokenId).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(mcpTokenId) {
    return { type: mcpTokenConstants.GET_BY_ID_REQUEST, payload: mcpTokenId };
  }
  function success(data) {
    return { type: mcpTokenConstants.GET_BY_ID_SUCCESS, payload: data };
  }
  function failure(error) {
    return { type: mcpTokenConstants.GET_BY_ID_FAILURE, payload: error };
  }
}

function getByClientId(clientId) {
  return (dispatch) => {
    dispatch(request(clientId));

    mcpTokenService.getByClientId(clientId).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(clientId) {
    return { type: mcpTokenConstants.GET_REQUEST, payload: { clientId } };
  }
  function success(data) {
    return { type: mcpTokenConstants.GET_SUCCESS, payload: data };
  }
  function failure(error) {
    return { type: mcpTokenConstants.GET_FAILURE, payload: error };
  }
}

function create(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    mcpTokenService.create(requestBody).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return { type: mcpTokenConstants.CREATE_REQUEST, payload: requestBody };
  }
  function success(data) {
    return { type: mcpTokenConstants.CREATE_SUCCESS, payload: data };
  }
  function failure(error) {
    return { type: mcpTokenConstants.CREATE_FAILURE, payload: error };
  }
}

function update(mcpTokenId, requestBody) {
  return (dispatch) => {
    dispatch(request({ mcpTokenId, ...requestBody }));

    mcpTokenService.update(mcpTokenId, requestBody).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return { type: mcpTokenConstants.UPDATE_REQUEST, payload: requestBody };
  }
  function success(data) {
    return { type: mcpTokenConstants.UPDATE_SUCCESS, payload: data };
  }
  function failure(error) {
    return { type: mcpTokenConstants.UPDATE_FAILURE, payload: error };
  }
}

function clearSuccess() {
  return { type: "CLEAR_MCP_TOKEN_SUCCESS" };
}
